<template>
  <aside class="wabunka-side-bar bg-gray4 fixed flex h-full min-h-screen w-48 flex-col overflow-y-scroll px-8 py-16">
    <img class="mb-10 w-24" src="@/assets/img/wabunka-logo.svg" />
    <div class="mb-8 flex-1">
      <ul class="ul">
        <li v-for="list in LISTS" :key="list.label" class="ul__item mb-2">
          <nuxt-link class="no-underline" :class="{ 'border-b-3 border-gray-900': $route.path === list.link }" :target="list.target" :to="list.link">
            {{ list.label }}
          </nuxt-link>
          <div v-show="list.children" class="mb-2"></div>
          <ul v-if="list.children" class="ul">
            <li v-for="child in list.children" :key="child.label" class="ul__item mb-2 ml-4">
              <nuxt-link
                class="no-underline"
                :class="{
                  'border-b-3 border-gray-900': $route.path === child.link,
                }"
                :target="child.target"
                :to="child.link"
              >
                {{ child.label }}
              </nuxt-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { useOtonamiAdminUrl } from '@/composables/utils/useOtonamiAdminUrl';

interface SidebarItemChild {
  link: string;
  label: string;
  target: '_blank' | '_self';
}

interface SidebarItem {
  link: string;
  label: string;
  target: '_blank' | '_self';
  children?: SidebarItemChild[];
}

const otonamiAdminUrl = useOtonamiAdminUrl();

// 事業者は Otonami 側の画面。Wabunka の管理画面は別ドメインなので絶対 URL にする
const LISTS: SidebarItem[] = [
  { link: otonamiAdminUrl('/providers'), label: '事業者', target: '_blank' },
  {
    link: '/wabunka/experiences',
    label: '体験マスタ',
    children: [
      { link: '/wabunka/experience-options', label: '体験オプション', target: '_self' },
      { link: '/wabunka/reservation-questions', label: '予約質問', target: '_self' },
      { link: '/wabunka/experience-sections', label: '体験セクション', target: '_self' },
    ],
    target: '_self',
  },
  {
    link: '/wabunka/experience-events',
    label: '体験イベント',
    target: '_self',
  },
  {
    link: '/wabunka/schedules',
    label: 'スケジュール',
    target: '_self',
  },
  {
    link: '/wabunka/reservations',
    label: '予約',
    target: '_self',
  },
  {
    link: '/wabunka/codes',
    label: 'コード',
    target: '_self',
  },
  {
    link: '/wabunka/interpreters',
    label: '通訳',
    target: '_self',
  },
  {
    link: '/wabunka/payment-advices',
    label: '支払通知書',
    children: [
      { link: '/wabunka/payment-advices', label: '支払通知書一覧', target: '_self' },
      { link: '/wabunka/payment-advices/bulk', label: '支払通知書一括処理', target: '_self' },
      { link: '/wabunka/payment-advices/detail', label: '支払通知書詳細', target: '_self' },
    ],
    target: '_self',
  },
  {
    link: '/wabunka/waitlists',
    label: 'ウェイトリスト',
    target: '_self',
  },
  {
    link: '/wabunka/itinerary-requests',
    label: 'Itinerary Requests',
    target: '_self',
  },
];
</script>

<style scoped>
@reference "@/assets/css/main.css";

.router-link-active {
  @apply border-b-2 border-gray-800;
}

.wabunka-side-bar {
  background-color: #d8c9c7;
}
</style>
